export class XplanCoverGrouped {
    public life:any =[];
    public tpd:any =[];
    public trauma:any =[];
    public income:any =[];
    public business:any =[];
    public additional:any =[];
    public severity:any =[];
}
